export default "__VITE_ASSET__CEf0rN3N__"